import { getIdReduxUtil } from '../get-id'
import addReferenceUtil from '../../../references/utils/add'
import setUtil from '../../../../utils/set'
import { getObjectUtil, uniqArrayUtil } from 'packages/src'
import sortByArrayUtil from 'packages/src/modules/array/sort-by'

function addInstanceToDateMapsReduxUtil (params) {
  const {
    state,
    instance,
    dateString,
    dateMapPath,
    suffixKey
  } = params

  const dateMap = { ...getObjectUtil(state, dateMapPath) }
  if (suffixKey && !dateMap[dateString]) {
    dateMap[dateString] = {}
    dateMap[dateString][suffixKey] = []
  } else if (suffixKey &&
    dateMap[dateString] &&
    !dateMap[dateString][suffixKey]) {
    dateMap[dateString][suffixKey] = []
  } else if (!dateMap[dateString]) {
    dateMap[dateString] = []
  }

  if (suffixKey) {
    dateMap[dateString][suffixKey] = sortByArrayUtil(uniqArrayUtil([
      getIdReduxUtil(instance),
      ...dateMap[dateString][suffixKey]
    ]), id => id * -1)
  } else {
    dateMap[dateString] = sortByArrayUtil(uniqArrayUtil([
      getIdReduxUtil(instance),
      ...dateMap[dateString]
    ]), id => id * -1)
  }

  const newState = setUtil(state, dateMapPath, dateMap)
  // Add a reference so if the workout log gets saved/deleted,
  // the dateMap gets updated
  const addReferenceObj = addReferenceUtil({
    instance: instance,
    referencePath: (
      suffixKey
        ? `${dateMapPath}.${dateString}.${suffixKey}`
        : `${dateMapPath}.${dateString}`
    ),
    state: newState
  })

  if (!addReferenceObj) {
    return newState
  }
  return addReferenceObj.state
}

export { addInstanceToDateMapsReduxUtil }
